<div class="row"><mat-spinner style="margin: auto;"></mat-spinner></div>
<div class="row"><p class="h3" style="margin:auto;">{{'Procesando'|translate}}...</p></div>
